import { Printer, X } from 'lucide-react';
import type { ReceiptData } from '../../domain/receipts/receiptTypes';
import {
  BrowserPrintReceiptPrinter,
  type ReceiptPaperWidth,
} from '../../services/printing/ReceiptPrinter';
import { ReceiptDocument } from './ReceiptDocument';
import { useState } from 'react';

type Props = { data: ReceiptData; onClose: () => void };
const printer = new BrowserPrintReceiptPrinter();

export function ReceiptDialog({ data, onClose }: Props) {
  const [width, setWidth] = useState<ReceiptPaperWidth>('80mm');
  return (
    <div className="fixed inset-0 z-[80] grid place-items-center bg-slate-950/50 p-4 print:bg-white print:p-0">
      <div className="flex max-h-[94dvh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl print:block print:max-h-none print:max-w-none print:overflow-visible print:shadow-none">
        <header className="flex items-center justify-between border-b border-slate-100 px-5 py-4 print:hidden">
          <div>
            <p className="text-[10px] font-extrabold uppercase tracking-widest text-[#00549C]">
              Receipt
            </p>
            <h2 className="text-xl font-black text-[#003B70]">Print customer receipt</h2>
          </div>
          <button
            onClick={onClose}
            className="grid h-11 w-11 place-items-center rounded-xl bg-slate-100"
            aria-label="Close"
          >
            <X />
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-auto bg-slate-100 p-5 print:overflow-visible print:bg-white print:p-0">
          <div className="receipt-preview mx-auto bg-white shadow-sm print:shadow-none">
            <ReceiptDocument data={data} width={width} />
          </div>
        </div>
        <footer className="flex flex-wrap items-center gap-3 border-t border-slate-100 p-4 print:hidden">
          <div className="flex rounded-xl border border-slate-200 p-1">
            {(['58mm', '80mm'] as ReceiptPaperWidth[]).map((option) => (
              <button
                key={option}
                onClick={() => setWidth(option)}
                className={`min-h-11 rounded-lg px-4 text-sm font-black ${width === option ? 'bg-[#DCEEFF] text-[#00549C]' : 'text-slate-500'}`}
              >
                {option}
              </button>
            ))}
          </div>
          <button
            onClick={() => printer.print(width)}
            className="ml-auto flex min-h-[56px] items-center gap-2 rounded-xl bg-[#00549C] px-6 text-lg font-black text-white"
          >
            <Printer size={20} /> PRINT RECEIPT
          </button>
        </footer>
      </div>
    </div>
  );
}
